import { forwardRef } from '@hover/blueprint';
import React from 'react';

import type { DesignerPaintProduct } from '../../types';

import { PaletteTile, type PaletteTileProps } from './PaletteTile';

export interface PaletteColorProps
  extends Omit<PaletteTileProps, 'label' | 'subLabel' | 'colorScheme'> {
  paintColor?: DesignerPaintProduct;
}

export const PaletteColor = forwardRef<PaletteColorProps, 'div'>(
  ({ paintColor, ...props }, ref) => {
    const { hex, primaryLabel, secondaryLabel, id } = paintColor ?? {};

    return (
      <PaletteTile
        label={primaryLabel}
        subLabel={secondaryLabel}
        tileProps={{ bgColor: hex }}
        value={String(id)}
        {...props}
        ref={ref}
      />
    );
  },
);
